import VerifyingRegistration from './VerifyingRegistration'
import { AccessType } from 'app/auth/accessControlService'

export const VerifyingRegistrationConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  routes: [
    {
      path: '/activate/:token',
      component: VerifyingRegistration,
      accesses: [AccessType.ANNONYMOUS],
    },
  ],
}
